module.exports = __webpack_public_path__ + "static/media/coaching-coachingSkills-powerfulQuestions-technique-fr.ce5bca3c.md";


//////////////////
// WEBPACK FOOTER
// ./src/data/pathways/coaching-coachingSkills-powerfulQuestions-technique-fr.md
// module id = 534
// module chunks = 18